/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "scroll-wrapper"
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [_c('div', {
    ref: "scroll-content"
  }, [_vm._t("default", function () {
    return [_c('div', {
      staticClass: "no-result-body"
    }, [_vm._t("nodata", function () {
      return [_vm._m(0)];
    })], 2)];
  })], 2), _vm._t("pullup", function () {
    return [_vm.pullUpLoad ? _c('div', {
      staticClass: "pullup-wrapper"
    }, [!_vm.isPullUpLoad ? _c('div', {
      staticClass: "before-trigger"
    }, [!_vm.noData ? _c('span', {
      staticClass: "no-more"
    }, [_vm._v(_vm._s(_vm.pullUpTxt))]) : _vm._e()]) : _c('div', {
      staticClass: "after-trigger"
    }, [_c('img', {
      staticClass: "scroll-loading",
      attrs: {
        "src": require('@/assets/loading.gif')
      }
    })])]) : _vm._e()];
  }, {
    "pullUpLoad": _vm.pullUpLoad,
    "isPullUpLoad": _vm.isPullUpLoad
  })], 2), _vm._t("pulldown", function () {
    return [_vm.pullDownRefresh ? _c('div', {
      ref: "pulldown",
      staticClass: "pulldown-wrapper",
      style: _vm.pullDownStyle
    }, [_vm.beforePullDown ? _c('div', {
      staticClass: "before-trigger"
    }, [_c('bubble', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.noData && _vm.isOverFlow,
        expression: "!noData && isOverFlow"
      }],
      attrs: {
        "y": _vm.bubbleY
      }
    })], 1) : _c('div', {
      staticClass: "after-trigger"
    }, [_vm.pulling ? _c('div', {
      staticClass: "loading"
    }, [_c('img', {
      staticClass: "scroll-loading",
      attrs: {
        "src": require('@/assets/loading.gif')
      }
    })]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.refreshTxt))])])])]) : _vm._e()];
  }, {
    "pullDownRefresh": _vm.pullDownRefresh,
    "pullDownStyle": _vm.pullDownStyle,
    "beforePullDown": _vm.beforePullDown,
    "pulling": _vm.pulling,
    "bubbleY": _vm.bubbleY
  })], 2);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "no-result"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/none.png"
    }
  })]);
}];
export { render, staticRenderFns };